import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import publishMyOrders from './views/publishMyOrders/publishMyOrders.vue'   
import publishAllOrders from './views/publishAllOrders/publishAllOrders.vue'
import pengdingOrders from './views/pengdingOrders/pengdingOrders.vue'
import pengdingMyOrders from './views/pengdingMyOrders/pengdingMyOrders.vue'
import pengdingAllOrders from './views/pengdingAllOrders/pengdingAllOrders.vue'
import roleManage from './views/roleManage/roleManage.vue'
import workManage from './views/workManage/workManage.vue'
// import dingManage from './views/dingManage/dingManage.vue'
import questionPool from './views/questionPool/questionPool.vue'
import orderDetail from './views/orderDetail/orderDetail.vue'
import reOrders from './views/reOrders/reOrders.vue'
import reOrderForm from './views/reOrdForm/reOrdForm.vue'
import reFormResult from './views/reFormResult/reFormResult.vue'
import searchDetail from './views/searchDetail/searchDetail.vue'
import Login from './views/login.vue'
import rolePermission from './views/rolePermission.vue'
import addQuestion from './views/addQuestion.vue'
import reviseLssues from './views/reviseLssues.vue'
import quesDetail from './views/quesDetail.vue'
import pendOrderDetail from './views/pendOrderDetail/pendOrderDetail.vue'
import phoneDetail from './views/phoneDetail/phoneDetail.vue'
import autOrderMana from './views/autOrderMana/autOrderMana.vue'
import phoneAddQuestion from './views/phoneAddQuestion.vue'
import orderStatistics from './views/orderStatistics/orderStatistics.vue'


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path:'/',
      name:'Login',
      component:Login
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main,
      children:[
        {
          path:'/publishAllOrders/publishAllOrders',
          name:'publishAllOrders',
          component:publishAllOrders
        },
        {
          path:'/publishMyOrders/publishMyOrders',
          name:'publishMyOrders',
          component:publishMyOrders
        },
        {
          path:'/pengdingOrders/pengdingOrders',
          name:'pengdingOrders',
          component:pengdingOrders
        },
        {
          path:'/pengdingMyOrders/pengdingMyOrders',
          name:'pengdingMyOrders',
          component:pengdingMyOrders
        },
        {
          path:'/pengdingAllOrders/pengdingAllOrders',
          name:'pengdingAllOrders',
          component: pengdingAllOrders
        },
        {
          path:'/roleManage/roleManage',
          name:'roleManage',
          component: roleManage
        },
        {
          path:'/workManage/workManage',
          name:'workManage',
          component: workManage
        },
        {
          path:'/questionPool/questionPool',
          name:'questionPool',
          component: questionPool
        },
        {
          path:'/orderDetail/orderDetail',
          name:'orderDetail',
          component:orderDetail
        },
        {
          path:'/reOrders/reOrders',
          name:'reOrders',
          component:reOrders
        },
        {
          path:'/reOrderForm/reOrderForm',
          name:'reOrdForm',
          component:reOrderForm
        },
        {
          path:'/reFormResult/reFormResult',
          name:'reFormResult',
          component:reFormResult
        },
        {
          path:'/searchDetail/searchDetail',
          name:'searchDetail',
          component:searchDetail
        },
        {
          path:'/rolePermission/rolePermission',
          name:'rolePermission',
          component:rolePermission
        },
        {
          path:'/addQuestion/addQuestion',
          name:'addQuestion',
          component:addQuestion
        },
        {
          path:'/reviseLssues/reviseLssues',
          name:'reviseLssues',
          component:reviseLssues
        },
        {
          path:'/quesDetail',
          name:'quesDetail',
          component:quesDetail
        },
        {
          path:'/pendOrderDetail',
          name:'pendOrderDetail',
          component:pendOrderDetail
        },
        {
          path:'/autOrderMana/autOrderMana',
          name:'autOrderMana',
          component:autOrderMana
        },
        {
          path:'/orderStatistics',
          name:'orderStatistics',
          component:orderStatistics
        }
      ]
    },
    {
      path:'/phoneDetail',
      name:'phoneDetail',
      component:phoneDetail
    },
    {
      path:'/phoneAddQuestion',
      name:'phoneAddQuestion',
      component:phoneAddQuestion
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
